export default function editLocationOfHousingCorporation(
  {patch}: any,
  {cid, lat, long}: {cid: number; lat: number; long: number},
): Promise<{}> {
  return patch(`/housing-corporations/location`, {lat, long, cid}, {retryOn401: true})
}



// WEBPACK FOOTER //
// ./src/api/endpoints/housingCorporations/editLocationOfHousingCorporation.tsx